import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Su dominio personalizzato (es. leadders.it) le API sono servite dalla stessa origine: evita chiamate cross-site
const sameOrigin = typeof window !== "undefined" && window.location.protocol === "https:"
  && !window.location.hostname.endsWith("emergentagent.com") && !window.location.hostname.endsWith("emergent.host");
export const API = `${sameOrigin ? window.location.origin : BACKEND_URL}/api`;

// Sessione in cookie httpOnly (session_token) impostato dal backend: nessun token in localStorage
const client = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

// Auth
export const login = (identifier, password) =>
  client.post("/auth/login", { identifier, password }).then((r) => r.data);
export const verifyTotp = (mfa_token, code) =>
  client.post("/auth/totp/verify", { mfa_token, code }).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  client.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);
export const resetUserTotp = (email) => client.post(`/users/${encodeURIComponent(email)}/reset-totp`).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me").then((r) => r.data);
export const googleSession = (session_id) =>
  client.post("/auth/google/session", { session_id }).then((r) => r.data);
export const logoutApi = () => client.post("/auth/logout").then((r) => r.data);

// Utenti CRM (admin)
export const listUsers = () => client.get("/users").then((r) => r.data);
export const createUser = (payload) => client.post("/users", payload).then((r) => r.data);
export const deleteUser = (email) => client.delete(`/users/${encodeURIComponent(email)}`).then((r) => r.data);

// Impostazioni sito & chatbot
export const getPublicSettings = () => client.get("/settings/public").then((r) => r.data);
export const getSettings = () => client.get("/settings").then((r) => r.data);
export const saveSettings = (payload) => client.put("/settings", payload).then((r) => r.data);
export const testEmail = () => client.post("/settings/test-email").then((r) => r.data);
export const testSms = () => client.post("/settings/test-sms").then((r) => r.data);
export const testInfocamere = () => client.post("/settings/test-infocamere").then((r) => r.data);
export const testWebSearch = () => client.post("/settings/test-web-search").then((r) => r.data);
export const testWhatsapp = () => client.post("/settings/test-whatsapp").then((r) => r.data);
export const getChatUsage = () => client.get("/settings/usage").then((r) => r.data);

// Vista Oggi & attività
export const getToday = () => client.get("/today").then((r) => r.data);
export const getCriticita = (stato) => client.get("/criticita", { params: stato ? { stato } : {} }).then((r) => r.data);
export const updateVerificaAzienda = (id, payload) => client.patch(`/leads/${id}/verifica-azienda`, payload).then((r) => r.data);
export const listActivities = (leadId) => client.get(`/leads/${leadId}/activities`).then((r) => r.data);
export const createActivity = (leadId, payload) => client.post(`/leads/${leadId}/activities`, payload).then((r) => r.data);
export const updateActivity = (id, payload) => client.patch(`/activities/${id}`, payload).then((r) => r.data);
export const deleteActivity = (id) => client.delete(`/activities/${id}`).then((r) => r.data);

// Richiami
export const listReminders = () => client.get("/reminders").then((r) => r.data);
export const syncReminders = () => client.post("/reminders/sync").then((r) => r.data);
export const sendReminderNow = (id) => client.post(`/reminders/${id}/send`).then((r) => r.data);
export const runDueReminders = () => client.post("/reminders/run-due").then((r) => r.data);

// Chat agente AI (pubblico)
export const startChat = (source = "leadders") => client.post("/chat/start", { source, website: "" }).then((r) => r.data);
export const sendChatMessage = (session_id, text) =>
  client.post("/chat/message", { session_id, text }).then((r) => r.data);

// Lead CRM (protetto)
export const listLeads = (params) => client.get("/leads", { params }).then((r) => r.data);
export const getLead = (id) => client.get(`/leads/${id}`).then((r) => r.data);
export const updateStage = (id, pipeline_stage, esito_finale) =>
  client.patch(`/leads/${id}/stage`, { pipeline_stage, esito_finale }).then((r) => r.data);
export const updateNote = (id, note_consulente) =>
  client.patch(`/leads/${id}/note`, { note_consulente }).then((r) => r.data);
export const deleteLead = (id) => client.delete(`/leads/${id}`).then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const getPipeline = () => client.get("/pipeline").then((r) => r.data);

// GDPR
export const listConsents = () => client.get("/consents").then((r) => r.data);
export const exportConsents = () =>
  client.get("/consents/export", { responseType: "blob" }).then((r) => r.data);
